import defaultSettings from '@/settings'

const title = defaultSettings.title || '聚能能源'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
